import React from "react";

const OrderDetailsPopup = ({ order, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
        >
          ×
        </button>

        {/* Order Details */}
        <h2 className="text-xl font-bold mb-4">Détails de la commande</h2>
        <div className="space-y-2 text-onWhite">
          <div>
            <strong>Titre :</strong> {order.title}
          </div>
          <div>
            <strong>Date :</strong> {order.date}
          </div>
          <div>
            <strong>Lieu :</strong> {order.location}
          </div>
          <div>
            <strong>Prix :</strong> ${order.price.toFixed(2)}
          </div>
          <div>
            <strong>Quantité :</strong> {order.quantity}
          </div>
          <div className="mt-4">
            <img
              src={order.image}
              alt={order.title}
              className="w-full h-40 object-cover rounded"
              loading="lazy"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300"
          >
            Fermer
          </button>
          <button
            onClick={() => console.log("Commande validée !")}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Valider
          </button>
          <button
            onClick={() => console.log("Commande rejetée !")}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Rejeter
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPopup;
